import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initQuoteSwiper = () => {
  const blocks = document.querySelectorAll('.wp-block-lb-quote');

  blocks.forEach((section) => {
    const swiperContainer = section.querySelector('.quotes-swiper');
    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,

      navigation: {
        nextEl: section.querySelector('.swiper-btn-next'),
        prevEl: section.querySelector('.swiper-btn-prev'),
      },

      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
};

document.addEventListener('DOMContentLoaded', initQuoteSwiper);

const initQuoteNavigationHeight = () => {
  const blocks = document.querySelectorAll('.wp-block-lb-quote');

  blocks.forEach((section) => {
    const quoteCard = section.querySelector('.quote__card');
    const navigation = section.querySelector('.quotes-navigation');

    if (!quoteCard || !navigation) return;

    const mediaQuery = window.matchMedia('(min-width: 992px)');

    const updateNavigationHeight = () => {
      if (mediaQuery.matches) {
        const cardHeight = quoteCard.offsetHeight;
        navigation.style.minHeight = `${cardHeight}px`;
        navigation.style.marginTop = `${cardHeight * -1}px`;
      } else {
        navigation.style.minHeight = '';
        navigation.style.marginTop = '';
      }
    };

    updateNavigationHeight();

    window.addEventListener('resize', updateNavigationHeight);

    mediaQuery.addEventListener('change', updateNavigationHeight);
  });
};

document.addEventListener('DOMContentLoaded', initQuoteNavigationHeight);
